import React from "react";
import HeroSlider from "../components/HeroSlider";
import MarketTicker from "../components/MarketTicker";
import ViopSection from "../components/ViopSection";
import BulletinForm from "../components/BulletinForm";
import WhyAcar from "../components/WhyAcar";
import MobileApp from "../components/MobileApp";

const Home = () => {
  return (
    <>
      <HeroSlider />
      <MarketTicker />
      <ViopSection />
      <BulletinForm />
      <WhyAcar />
      <MobileApp />
    </>
  );
};

export default Home;
